var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5.771,
    height: 11.295,
    viewBox: "0 0 5.771 11.295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38906",
    "data-name": "Group 38906",
    transform: "translate(-381 -169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_7787532_next_arrow_direction_down_left_icon",
    "data-name": "7787532_next_arrow_direction_down_left_icon",
    d: "M59.419,23.415l3.954-3.954a.693.693,0,1,1,.98.98L60.4,24.4a.677.677,0,0,0,0,.98l3.989,3.989a.693.693,0,1,1-.98.98L59.454,26.39A2.1,2.1,0,0,1,59.419,23.415Z",
    transform: "translate(322.18 149.748)",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.0187b96aea846d7bcd5fa311a25bc94d.svg";
export { ForwardRef as ReactComponent };